import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@common/components/components.module';
import { EmployeesViewComponent } from './views/employeesView/employeesView.component';
import { EmployeeDetailsViewComponent } from './views/employeeDetailsView/employeeDetailsView';
import { AddEditEmployeeViewComponent } from './views/addEditEmployeeView/addEditEmployeeView.component';

@NgModule({
  declarations: [
    AddEditEmployeeViewComponent,
    EmployeesViewComponent,
    EmployeeDetailsViewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ComponentsModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  exports: [],
})
export class EmployeesModule {}



// WEBPACK FOOTER //
// ./src/app/modules/employees/employees.module.ts